import { useUser } from '@/app/providers/UserProvider';
import { Sidepanel } from '@/components/layout/Sidepanel';
import { useTranslation } from 'react-i18next';
import { CompanyAdminContentView } from '../../company-admin/CompanyAdminContentView';
import { CreateCompany } from '../../company-admin/components/CreateCompany';
import type { CompanyInfo, CompanySidePanelContent } from '../types';
import { cn } from '@/lib';
import { scrollStyleClass } from '@/utils/scrollClassHelper';

interface CompanySidePanelHandlerProps {
  content: CompanySidePanelContent | null;
  panelKey: string | null;
  isOpen: boolean;
  onClose: () => void;
  onContentChange?: (content: CompanySidePanelContent) => void;
}

export function CompanySidePanelHandler({
  content,
  panelKey,
  isOpen,
  onClose,
  onContentChange,
}: CompanySidePanelHandlerProps) {
  const { t } = useTranslation();
  const currentUser = useUser();

  if (!content || !panelKey) return null;

  const getTitle = () => {
    switch (content.type) {
      case 'create':
        return t('companies.sidePanel.newCompany');
      case 'view':
        return content.company.name;
    }
  };

  const handleCompanyCreated = (company: CompanyInfo) => {
    onContentChange?.({ type: 'view', company });
  };

  return (
    <Sidepanel
      key={panelKey}
      isOpen={isOpen}
      onClose={onClose}
      title={getTitle()}
      className="sm:w-[70vw]"
    >
      {content.type === 'create' && (
        <div className={cn("relative px-8 overflow-scroll h-full space-y-4 flex-1 min-h-0 w-full min-w-0 flex flex-col", scrollStyleClass)}>
          <CreateCompany
            onCreatedSuccessfully={(company) =>
              handleCompanyCreated({ name: company.name, uuid: company.uuid })
            }
            withCompanyContact={false}
            parentCompany={currentUser.user?.companyUuid}
            showLevelSelect={true}
            currentCompanyId={currentUser.user?.companyUuid}
            showCustomerIdField={true}
          />
          
        </div>
      )}
      {content.type === 'view' && (
        <CompanyAdminContentView
          companyUuid={content.company.uuid}
          showAdminSection={true}
        />
      )}
    </Sidepanel>
  );
}
